document.addEventListener("DOMContentLoaded", () => {
  const unlockButtons = document.querySelectorAll(
    ".unlock-master-class-button"
  );
  const closeButton = document.querySelector(".close-button");
  const masterClassForm = document.querySelector(
    ".master-class-signup-form-class"
  );
  const modalOverlay = document.querySelector(
    ".master-class-signup-form-overlay"
  );

  function openModal() {
    masterClassForm.style.display = "flex";
    modalOverlay.style.display = "block";
  }

  function closeModal() {
    masterClassForm.style.display = "none";
    modalOverlay.style.display = "none";
  }

  if (unlockButtons.length > 0) {
    unlockButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        openModal();
      });
    });
  }

  if (modalOverlay) {
    modalOverlay.addEventListener("click", closeModal);
  }

  if (closeButton) {
    closeButton.addEventListener("click", closeModal);
  }
});
